import req from "../http";

// 發送信件
const sendmail = {
  // 職缺意願
  jobIntention(params) {
    return req("post", "/Notice/JobIntention", params);
  },

  // 預覽 面談邀約
  previewInterviewInvitation(params) {
    return req("post", "/Recruitment/InterviewInvitation/Preview", params);
  },

  // 預覽 感謝函
  previewThanksMail(params) {
    return req("post", "/Notice/Thanks/Batch/Preview", params);
  },

  // 預覽 錄取通知
  previewHireMail(params) {
    return req("post", "/Notice/Hire/Preview", params);
  },

  // 預覽 報到通知
  previewReportMail(params) {
    return req("post", "/Notice/Report/Preview", params);
  },

  // 預覽 錄取通知
  previewJobIntention(params) {
    return req("post", "/Notice/JobIntention/Preview", params);
  },

  // 寄出 面談邀約
  interviewInvitation(params) {
    return req("post", "/Recruitment/InterviewInvitation", params);
  },

  // 面談邀約(不發送mail)
  interviewInvitationNoMail(params) {
    return req("post", "/Recruitment/InterviewInvitation/NoMail", params);
  },

  // 重新邀約
  reInterviewInvitation(params) {
    return req("post", "/Recruitment/ReInterviewInvitation", params);
  },

  // 重新邀約(不發送mail)
  reInterviewInvitationNoMail(params) {
    return req("post", "/Recruitment/ReInterviewInvitation/NoMail", params);
  },

  // 感謝函
  thanksMail(params) {
    return req("post", "/Notice/Thanks/Batch", params);
  },
};

export default sendmail;
